'use strict';

(function () {
    'use strict';

    angular.module('app.dashboard', ['blocks.router', 'app.iot', 'app.open-data']);
})();